import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}`;

export default {
  list(params = {}) {
    return axios.get(`${API_URL}admin/leaves`, {
      params,
      headers: buildHeaders(),
    });
  },
  stats(params = {}) {
    return axios.get(`${API_URL}admin/leaves/stats`, {
      params,
      headers: buildHeaders(),
    });
  },
  approve(id) {
    return axios.post(
      `${API_URL}admin/leaves/${id}/approve`,
      {},
      { headers: buildHeaders() }
    );
  },
  decline(id, data = {}) {
    return axios.post(`${API_URL}admin/leaves/${id}/decline`, data, {
      headers: buildHeaders(),
    });
  },
  bulkApprove(ids) {
    return axios.post(
      `${API_URL}admin/leaves/bulk-approve`,
      { ids },
      { headers: buildHeaders() }
    );
  },
  bulkDecline(ids, data = {}) {
    return axios.post(
      `${API_URL}admin/leaves/bulk-decline`,
      { ids, ...data },
      { headers: buildHeaders() }
    );
  },
  revoke(id, data = {}) {
    return axios.post(`${API_URL}admin/leaves/${id}/revoke`, data, {
      headers: buildHeaders(),
    });
  },
  create(data = {}) {
    return axios.post(`${API_URL}admin/leaves`, data, {
      headers: buildHeaders(),
    });
  },
  employeeSummary(params = {}) {
    return axios.get(`${API_URL}admin/leaves/employee-summary`, {
      params,
      headers: buildHeaders(),
    });
  },

  // ---------- REPORT / CHART / EXPORT ----------
  summary(params = {}) {
    // dynamic chart data per year / leave type
    return axios.get(`${API_URL}reports/leaves/summary`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportPdf(params = {}) {
    return axios.get(`${API_URL}reports/leaves/export-pdf`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCsv(params = {}) {
    return axios.get(`${API_URL}reports/leaves/export-csv`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // 🔹 NEW: chart data (for "Leaves" bar chart)
  chart(params = {}) {
    return axios.get(`${API_URL}admin/leaves/chart`, {
      params,
      headers: buildHeaders(),
    });
  },

  // 🔹 NEW: export (pdf/csv) for report page
  exportReport(format = "csv", params = {}) {
    return axios.get(`${API_URL}admin/leaves/export`, {
      params: { ...params, format },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
